{
  "version": 1,
  "asset_id": "adc94221-c95b-4e99-8765-d5370b681526",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/adc94221-c95b-4e99-8765-d5370b681526/aleph-commodities-800.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/adc94221-c95b-4e99-8765-d5370b681526/aleph-commodities-800.webp",
  "original_filename": "aleph-commodities-800.webp",
  "size": 136052,
  "content_type": "image/webp",
  "created_at": "2026-10-20T23:04:52Z"
}
